import { Component, Input } from "@angular/core";
import { faDatabase, faIdCard, faMoneyBills, faSearch, faSimCard } from "@fortawesome/free-solid-svg-icons";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { catchError } from "rxjs/operators";
import { AppToastService } from "src/app/components/toasts/app-toast.service";
import { HttpReportDayEndService } from "src/app/modules/kiosk/http-report-day-end.service";
import { ReportDayEndDto } from "src/app/modules/kiosk/dto";
import { UtilService } from "src/app/modules/kiosk/util.service";

@Component({
	selector: 'app-report-day-end-table-data',
	templateUrl: './report-day-end-table-data.component.html',
	styleUrls: ['./report-day-end-table-data.component.scss']
})
export class ReportDayEndTableDataComponent {

	@Input() payload: ReportDayEndDto[];

	util = UtilService;

	view = faSearch;

	constructor(
		private modalService: NgbModal,
		private httpService: HttpReportDayEndService,
		private spinner: NgxSpinnerService,
		private toastService: AppToastService,) {}

	downloadReport(report: ReportDayEndDto) {
		this.httpService.getReportFile(report.id).subscribe({
			next: (blob) => {
				const url = window.URL.createObjectURL(blob);
				const a = document.createElement('a');
				a.href = url;
				a.download = report.reportFileName;
				a.click();
				window.URL.revokeObjectURL(url);
			},
			error: (err) => {
				console.error('Download failed', err);
			}
		});
	}

}